import type { ToneOverlay } from "../index.js";

export const overlay: ToneOverlay = {
  "alert.toast.new": "{hazard} a prop. Anotat.",
  "alert.toast.escalation": "{hazard} a prop. Ara pitjor.",
  "alert.toast.inPath": "{hazard} cap a tu. Lògic.",
  "alert.toast.allClear": "Normal altra vegada prop de {place}.",
  "alert.toast.tap": "Detalls, si t'interessa.",
  "alert.takeover.title": "{hazard}. És el moment de moure's.",
  "alert.takeover.details": "Els detalls",
  "alert.takeover.dismiss": "Anotat",
  "now.status.allClear": "Sense novetat.",
  "now.status.stayAware": "Ulls oberts.",
  "now.status.sub.allClear": "Res dins del teu radi. Gaudeix-ho.",
  "now.activity.empty": "Ningú no ha informat de res. Sospitós.",
  "onboarding.promise.tagline": "Veïns avisant veïns. Revolucionari.",
  "onboarding.promise.continue": "Bé, anem",
  "onboarding.home.browse": "Només mirant",
  "you.voice.intro": "Tria de directe que vols que sigui això.",
};
